/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectDomainData
 */
export interface CrmProjectDomainData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectDomainData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectDomainData
     */
    active?: boolean;
}

/**
 * Check if a given object implements the CrmProjectDomainData interface.
 */
export function instanceOfCrmProjectDomainData(value: object): value is CrmProjectDomainData {
    return true;
}

export function CrmProjectDomainDataFromJSON(json: any): CrmProjectDomainData {
    return CrmProjectDomainDataFromJSONTyped(json, false);
}

export function CrmProjectDomainDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectDomainData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CrmProjectDomainDataToJSON(json: any): CrmProjectDomainData {
    return CrmProjectDomainDataToJSONTyped(json, false);
}

export function CrmProjectDomainDataToJSONTyped(value?: CrmProjectDomainData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'active': value['active'],
    };
}

